import { checkFeature } from '@bybeam/platform-lib/features/check';
import { FeatureName } from '@bybeam/platform-types';
import usePartner from '@platform-ui-common/hooks/contexts/usePartner.js';
import useCase from '@platform-ui/case/hooks/useCase.js';
import PanelWrapper from '../PanelWrapper.js';
import SendMessagePanel from '../SendMessagePanel.js';
import ActivityFeed from './ActivityFeed.js';

export default function ActivityFeedPanel(): JSX.Element {
  const partner = usePartner();
  const { case_ } = useCase();
  return (
    <div className="w-full flex flex-col gap-1">
      <PanelWrapper title="Activity" overflow titleTag="h2">
        <div className="flex flex-col gap-5">
          <ActivityFeed workflowEvents={case_.workflowEvents} />
        </div>
      </PanelWrapper>
      {checkFeature(partner?.features, FeatureName.ApplicantComments) && <SendMessagePanel />}
    </div>
  );
}
